import styled from 'styled-components';

const Setting = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 5px;
`;

const Link = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
  text-align: center;
  line-height: 1.5;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;

const Value = styled.div`
  font-weight: bold;
`;

export { Setting, Wrapper, Link, Value };
